
import React, { Component } from 'react';
import { connect } from 'react-redux'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';

var viewUtil = require('../../utils/view/viewUtil');
const translator = require('../../utils/translator/translator');

class PromptContainer extends Component 
{
    render()
    {
        if (this.props.promptDialogue == null)
            return null;

        let onNo = ()=>{
                            viewUtil.closePrompt();

                            if (this.props.promptDialogue.onNo != null)
                                this.props.promptDialogue.onNo();
                       }

        let onYes = ()=>{
                            viewUtil.closePrompt();
                            
                            if (this.props.promptDialogue.onYes != null)
                                this.props.promptDialogue.onYes();
                        }

        return(<Modal isOpen={true} centered animation={false} fade={false} style={{minWidth:'20vw'}}>
                <ModalHeader cssModule={{ 'modal-title': 'w-100' }} style={{background:'var(--colors-white)', paddingBottom:'5px'}}>
                    <div className="caption primary-color d-flex justify-content-center">
                        {this.props.promptDialogue.title}
                    </div>
                </ModalHeader>
                <ModalBody style={{background:'var(--background-color)'}}>
                    <div style={{textAlign:'center'}}>
                        {this.props.promptDialogue.message}
                    </div>
                    <div style={{textAlign:'center'}}>
                        {this.props.promptDialogue.confirmationMessage}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='btn-cancel' onClick={onNo} style={{marginRight:'10px'}}>{translator.getLabel("cancel")}</Button>
                    <Button className='btn-ok' onClick={onYes}>{translator.getLabel("confirm")}</Button>
                </ModalFooter>
            </Modal>);

          
    }
}

const mapStateToProps = state => 
{
    return { 
                promptDialogue: state.promptDialogue
           }
}

export default connect(mapStateToProps)(PromptContainer)